export enum BrowserEventEnum {
    OFFLINE = "offline",
    ONLINE = "online",
}
